import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { WebhookDelivery } from "types/generated";

const WebhookDeliveriesTableTimestampCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<WebhookDelivery>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={item.timestamp} variant="p-body3" />
    </TableSimpleCell>
  );
};

export default WebhookDeliveriesTableTimestampCell;
